import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingSearchList: false,
  isFetchingEnabledList: false,
  isFetchingWithVendor: false,
  isFetchingName: false,
  isFetchingPCP: false,
  isFetchingArc: false,
  isFetchingIpaAdvise: false,
  isFetchingWithCity: false,
  isFetchingWithName: false,
  isPostingAck: false,
  isCheckingFollowUp: false,
  isFetchingAllIpaProv: false,
  isSearching: false,
  isSearchingAll: false,
  isFetchingSelectedUserId: false,
  isFetchingProviderHcc: false,
  isFetchingCECProviders: false,
  isGettingEzProviderDetails: false,
  isCheckingProvAuthSubmission: false,

  result: [],
};

const authProviderReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_PROVIDER_WITH_VENDOR_INFO_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingWithVendor: true,
      };

    case types.GET_PROVIDER_WITH_VENDOR_INFO_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingWithVendor: false,
      };

    case types.GET_PROVIDER_WITH_VENDOR_INFO_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingWithVendor: false,
      };

    case types.GET_PROVIDER_NAME_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingName: true,
      };

    case types.GET_PROVIDER_NAME_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingName: false,
      };

    case types.GET_PROVIDER_NAME_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingName: false,
      };

    case types.IS_PCP_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingPCP: true,
      };

    case types.IS_PCP_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingPCP: false,
      };

    case types.IS_PCP_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingPCP: false,
      };

    case types.IS_ARCADIA_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingArc: true,
      };

    case types.IS_ARCADIA_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingArc: false,
      };

    case types.IS_ARCADIA_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingArc: false,
      };

    case types.GET_IPA_ADVISE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchinIpaAdvise: true,
      };

    case types.GET_IPA_ADVISE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchinIpaAdvise: false,
      };

    case types.GET_IPA_ADVISE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchinIpaAdvise: false,
      };

    case types.GET_AUTH_SEARCH_PROVIDER_LIST_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingSearchList: true,
      };

    case types.GET_AUTH_SEARCH_PROVIDER_LIST_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingSearchList: false,
      };

    case types.GET_AUTH_SEARCH_PROVIDER_LIST_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingSearchList: false,
      };

    case types.GET_PROVIDER_BY_CITY_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingWithCity: true,
      };

    case types.GET_PROVIDER_BY_CITY_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingWithCity: false,
      };

    case types.GET_PROVIDER_BY_CITY_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingWithCity: false,
      };

    case types.GET_PROVIDER_BY_NAME_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingWithName: true,
      };

    case types.GET_PROVIDER_BY_NAME_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingWithName: false,
      };

    case types.GET_PROVIDER_BY_NAME_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingWithName: false,
      };

    case types.GET_AUTH_ENABLED_PROVIDER_LIST_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingAuthEnabledList: true,
      };

    case types.GET_AUTH_ENABLED_PROVIDER_LIST_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingAuthEnabledList: false,
      };

    case types.GET_AUTH_ENABLED_PROVIDER_LIST_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingAuthEnabledList: false,
      };

    case types.POST_ACKNOWLEDGEMENT_REQUEST:
      return {
        ...state,
        result: [],
        isPostingAck: true,
      };

    case types.POST_ACKNOWLEDGEMENT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isPostingAck: false,
      };

    case types.POST_ACKNOWLEDGEMENT_FAILURE:
      return {
        ...state,
        result: [],
        isPostingAck: false,
      };

    case types.CHECK_INITIAL_FOLLOW_UP_REQUEST:
      return {
        ...state,
        result: [],
        isCheckingFollowUp: true,
      };

    case types.CHECK_INITIAL_FOLLOW_UP_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isCheckingFollowUp: false,
      };

    case types.CHECK_INITIAL_FOLLOW_UP_FAILURE:
      return {
        ...state,
        result: [],
        isCheckingFollowUp: false,
      };

    case types.GET_ALL_IPA_PROVIDERS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingAllIpaProv: true,
      };

    case types.GET_ALL_IPA_PROVIDERS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingAllIpaProv: false,
      };

    case types.GET_ALL_IPA_PROVIDERS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingAllIpaProv: false,
      };

    case types.SEARCH_ALL_PROVIDERS_REQUEST:
      return {
        ...state,
        result: [],
        isSearchingAll: true,
      };

    case types.SEARCH_ALL_PROVIDERS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSearchingAll: false,
      };

    case types.SEARCH_ALL_PROVIDERS_FAILURE:
      return {
        ...state,
        result: [],
        isSearchingAll: false,
      };

    case types.GET_AUTH_PROVIDER_HCC_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingProviderHcc: true,
      };

    case types.GET_AUTH_PROVIDER_HCC_SUCCESS:
      return {
        ...state,
        result: [],
        isFetchingProviderHcc: false,
      };

    case types.GET_AUTH_PROVIDER_HCC_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingProviderHcc: false,
      };

    case types.GET_CEC_PROVIDERS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingCECProviders: true,
      };

    case types.GET_CEC_PROVIDERS_SUCCESS:
      return {
        ...state,
        result: [],
        isFetchingCECProviders: false,
      };

    case types.GET_CEC_PROVIDERS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingCECProviders: false,
      };

      case types.GET_PROVIDER_TERM_DATE_REQUEST:
        return {
          ...state,
          result: [],
          isGettingProvTermDate: true,
        };

      case types.GET_PROVIDER_TERM_DATE_SUCCESS:
        return {
          ...state,
          result: action.payload,
          isGettingProvTermDate: false,
        };

      case types.GET_PROVIDER_TERM_DATE_FAILURE:
        return {
          ...state,
          result: [],
          isGettingProvTermDate: false,
      };

      case types.GET_EZ_PROVIDER_DETAILS_REQUEST:
        return {
          ...state,
          result: [],
          isGettingEzProviderDetails: true,
        };

      case types.GET_EZ_PROVIDER_DETAILS_SUCCESS:
        return {
          ...state,
          result: action.payload,
          isGettingEzProviderDetails: false,
        };

      case types.GET_EZ_PROVIDER_DETAILS_FAILURE:
        return {
          ...state,
          result: [],
          isGettingEzProviderDetails: false,
        };

        case types.GET_CHECK_PROVIDER_AUTH_SUBMISSION_REQUEST:
          return {
            ...state,
            result: [],
            isCheckingProvAuthSubmission: true,
          };
  
        case types.GET_CHECK_PROVIDER_AUTH_SUBMISSION_SUCCESS:
          return {
            ...state,
            result: action.payload,
            isCheckingProvAuthSubmission: false,
          };
  
        case types.GET_CHECK_PROVIDER_AUTH_SUBMISSION_FAILURE:
          return {
            ...state,
            result: [],
            isCheckingProvAuthSubmission: false,
          };

    default:
      return state;
  }
};

export default authProviderReducer;
